import { useStaticQuery, graphql } from 'gatsby'

export function useDataFifthScreenByEn() {
    const data = useStaticQuery(graphql`
        {
            totalNum: datoCmsRenshinPageMain(title: { eq: "Slide 5: Block 1, title" }, locale: { eq: "en" }) {
                value
            }

            totalText: datoCmsRenshinPageMain(title: { eq: "Slide 5: Block 1, value" }, locale: { eq: "en" }) {
                value
            }

            itemTitle_1: datoCmsRenshinPageMain(title: { eq: "Slide 5: Block 2, title" }, locale: { eq: "en" }) {
                value
            }

            itemText_1: datoCmsRenshinPageMain(title: { eq: "Slide 5: Block 2, value" }, locale: { eq: "en" }) {
                value
            }

            itemTitle_2: datoCmsRenshinPageMain(title: { eq: "Slide 5: Block 3, title" }, locale: { eq: "en" }) {
                value
            }

            itemText_2: datoCmsRenshinPageMain(title: { eq: "Slide 5: Block 3, value" }, locale: { eq: "en" }) {
                value
            }
        }
    `)

    return data
}
